/**
 * Utilitários para feriados do calendário (datas YYYY-MM-DD).
 */

/** @param {string} dateStr */
export function holidayYear(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') return null;
    const m = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return null;
    return parseInt(m[1], 10);
}

/**
 * Ajusta a data para o ano alvo, preservando mês/dia (29/02 vira 28/02 em ano não bissexto).
 * @param {string} dateStr - YYYY-MM-DD
 * @param {number} targetYear
 * @returns {string|null} YYYY-MM-DD
 */
export function shiftHolidayDateToYear(dateStr, targetYear) {
    const y = holidayYear(dateStr);
    if (y == null) return null;
    const parts = dateStr.split(/[-T]/);
    if (parts.length < 3) return null;
    let month = parseInt(parts[1], 10);
    let day = parseInt(parts[2], 10);
    if (month === 2 && day === 29) {
        const leap = (yr) => (yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0;
        if (!leap(targetYear)) day = 28;
    }
    const d = new Date(targetYear, month - 1, day);
    if (Number.isNaN(d.getTime())) return null;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
}

/** @param {{ data_feriado: string }} h */
function holidaySortKey(h) {
    return h.data_feriado || '';
}

/**
 * Replica feriados de um ano para outro (novos itens com ids temporários).
 * Não duplica datas que já existem no ano destino.
 *
 * @param {Array<{ id?: string|number, nome: string, data_feriado: string }>} allHolidays
 * @param {number} sourceYear
 * @param {number} targetYear
 */
export function replicateHolidaysForYear(allHolidays, sourceYear, targetYear) {
    if (sourceYear === targetYear) return [];
    const source = allHolidays.filter((h) => holidayYear(h.data_feriado) === sourceYear);
    const existingDates = new Set(
        allHolidays.filter((h) => holidayYear(h.data_feriado) === targetYear).map((h) => h.data_feriado)
    );
    const additions = [];
    for (const h of source) {
        const newDate = shiftHolidayDateToYear(h.data_feriado, targetYear);
        if (!newDate || existingDates.has(newDate)) continue;
        existingDates.add(newDate);
        additions.push({
            id: `temp_${crypto.randomUUID?.() || `${Date.now()}_${Math.random()}`}`,
            nome: h.nome,
            data_feriado: newDate
        });
    }
    return additions;
}

/**
 * Anos presentes nas datas + ano atual (para o seletor).
 * @param {Array<{ data_feriado: string }>} holidays
 * @param {number} extraYear — ano em foco na UI
 */
export function collectYearOptions(holidays, extraYear) {
    const set = new Set();
    const current = new Date().getFullYear();
    set.add(current);
    if (extraYear != null) set.add(extraYear);
    holidays.forEach((h) => {
        const y = holidayYear(h.data_feriado);
        if (y != null) set.add(y);
    });
    return [...set].sort((a, b) => a - b);
}

export function sortHolidaysByDate(list) {
    return [...list].sort((a, b) => holidaySortKey(a).localeCompare(holidaySortKey(b)));
}
